export * as buildFunctional from './build-functional'
export * as changeManagement from './change-management'
export * as dataIntegration from './data-integration'
export * as dataMigration from './data-migration'
export * as marketingCloud from './marketing-cloud'
export * as projectManagement from './project-management'
export * as reportingAndAnalytics from './reporting-and-analytics'
export * as technical from './technical'
